import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { RequestHelper } from "../Helpers/RequestHelper.js";
import { Stepper } from "./component/Stepper.js";
import { Popup } from "./component/Popup.js";
import { DynamicList } from "./component/DynamicList.js";
import { DataDriver } from "../Drivers/DataDriver.js";

export class FinancingForm {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "financing-form-container";
        this.popups = [];
    }

    init() {
        // this.updateVehicleImageSrc();

        this.setupFinanceForm();
        this.setupPopups();

        this.eventHandlers();
        this.setFormAction();
    }

    getFormElement() {
        return document.querySelector(this.app.getSelector("#pmdrs-financing-form"));
    }

    setFormAction() {
        let action = "http://localhost:83/pm-motors-secure/index.php";
        if (this.app.pmdrs.config.production) {
            action = "https://secure.dev.pixelmotiondemo.com/";
        }
        this.getFormElement().action = action;
    }

    setupFinanceForm() {
        let pmdrs = this.app.pmdrs;


        let hostname = window.location.hostname;
        const devSitePrefix = ".dev";
        // if driver is not pixelmotion, and it's not a dev site, hide the 'submit your offer' button
        if (false && !pmdrs.dataDriver.isPixelmotion() && !pmdrs.config.dev) {
            let buttons = document.querySelectorAll("#submit-open-modal-retailing");
            // console.log(buttons);
            // let submitButton = document.querySelector(
            //     this.app.getSelector("#submit-open-modal-retailing")
            // );
            for (const button of buttons) {
                DOMHelper.addClass(button, "hide-button");
            }
            // DOMHelper.addClass(submitButton, "hide-button");
        }

        var thisFinancingForm = this;
        //form stepper
        this.stepper = new Stepper(this.app, "ff-stepper", "<i class='fa fa-edit'></i> Apply for Credit");
        this.stepper.addStep({
            content: `<div class="financing-form-page1">

	<h2 class="section-title">Applicant Contact Info</h2>

	<div class="inputs-section">
		<label class="drs-field-label">Application Type</label>
		<br>
		<input class="drs-input" type="radio" name="applicationType" value="individual" required>
		<label>Individual</label>

		<input class="drs-input" type="radio" name="applicationType" value="joint">
		<label>Joint</label>
		
		<a class="white-space-nowrap" href="#" data-targetid="application_disclaimer_popup_content" data-title="Disclaimer" id="aplication_disclaimer_popup_btn">View Disclaimer</a>

		<div class="pmdrs-popup-content" id="application_disclaimer_popup_content">
			Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
			tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
			quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
			consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
			cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
			proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
		</div>
		<hr>

		<label class="drs-field-label">Name</label>
		<div class="d-flex">
			<input class="only-letters" type="text" name="firstName" placeholder="First" required>
			<input class="only-letters" type="text" name="lastName" placeholder="Last" required>
		</div>

		<hr>

		<label class="drs-field-label">Primary Phone Number</label>
		<div class="d-flex">
			<select name="phoneType">
				<option value="home">Home</option>
				<option value="cell">Cell</option>
			</select>
			<input type="text" name="phone" placeholder="Phone Number">
		</div>

		<label class="drs-field-label">Email</label>
		<input type="email" name="email" required>

		<label class="drs-field-label">Verify Email</label>
		<input type="email" name="emailConfirmation" required>

		<hr>

		<label class="drs-field-label">Salesperson's Name (Optional)</label>
		<div class="d-flex">
			<input type="text" name="salesFirstName" placeholder="First">
			<input type="text" name="salesLastName" placeholder="Last">
		</div>


	</div>

</div>`,
            nextText: "Applicant Housing",
            validation: () => {
                return thisFinancingForm.stepValidation(0);
            },
        });

        this.stepper.addStep({
            content: `<div class="financing-form-page2">
	<h2 class="section-title">Applicant Housing</h2>

	<div class="inputs-section">
		<label class="drs-field-label">Address</label>

		<div>
			<input type="checkbox" name="ruralRoute">
		  	<label>I Have a Rural Route <i class="fa fa-question-mark"></i></label>
		</div>

		<div class="d-flex">
			<input type="text" name="address1" placeholder="Address Line 1" required>
			<input type="text" name="address2" placeholder="Address Line 2" required>
			<input type="text" name="cityStateZip" placeholder="City State Zip" required>
			<!-- <select name="addressStreetType">
				<option value="0">Select Street Type</option>
				<option value="type1">Type 1</option>
			</select> -->
		</div>

		<input type="text" name="aptNumber" placeholder="Apt #" style="max-width: 250px" required>

		<hr>

		<div class="d-flex justify-space-between">
			<div>
				<label class="drs-field-label">Housing Status</label>
				<select name="housingStatus">
					<option value="0">Select Housing Status</option>
					<option >Mortgage</option>
					<option >Rent</option>
					<option >Own Outright</option>
					<option >Military</option>
					<option >Family</option>
					<option >Other</option>
				</select>
			</div>

			<div>
				<label class="drs-field-label">Time at Address</label>
				<div class="d-flex align-items-center">
					<input style="max-width:75px" type="number" name="yearsAtAddress" required>
					&nbsp;<span>Years</span>&nbsp;

					<input style="max-width:75px" type="number" name="monthsAtAddress" required>
					&nbsp;<span>Months</span>
				</div>
			</div>

			<div>
				<label class="drs-field-label">Mortgage Payment/Rent</label>
				<div class="d-flex align-items-center">
					<span>$</span>&nbsp;
					<input type="text" name="rentInUSD" required> &nbsp;
					<span>/Month</span>
				</div>
			</div>
		</div>


		<hr>

		<label class="drs-field-label">Date of Birth</label>
		<div class="d-flex align-items-center">
			<input style="max-width: 300px" type="date" name="birthday" required>&nbsp;
			<span>(mm/dd/yyyy)</span>
		</div>

		<label class="drs-field-label">SSN / ITIN</label>
		<div class="d-flex align-items-center">
			<input id="finance_ssn_txt" style="max-width:300px" type="text" name="ssnItin" required>&nbsp;
			<a class="white-space-nowrap" href="#" data-targetid="ssn_popup_content" data-title="SSN / ITIN" id="ssn_popup_btn"><i class="fa fa-lock"></i> Why do we need this?</a>
		</div>
		<div class="pmdrs-popup-content" id="ssn_popup_content">
			Please enter your Social Security Number or Individual Taxpayer Identification Number to ensure we're reviewing the correct credit report information while we consider your application.
		</div>
		<p class="note">Note Your personal information is secure</p>


	</div>
</div>`,
            nextText: "Applicant Employment",
            validation: () => {
                return thisFinancingForm.stepValidation(1);
            },
        });

        this.stepper.addStep({
            content: `<div class="financing-form-page3">
	<h2 class="section-title">Applicant Employment</h2>

	<div class="inputs-section">		
		<div class="d-flex">
			<div style="flex: 1">
				<label class="drs-field-label">Employment Status</label>
				<select name="employmentStatus">
					<option value="0">Select Employment Status</option>
					<option >Employed</option>
					<option >Unemployed</option>
					<option >Self-Employed</option>
					<option >Student</option>
					<option >Retired</option>
					<option >Active Militar</option>
					<option >Retired Militar</option>
					<option >Other</option>
				</select>
			</div>

			<div style="flex: 1">
				<label class="drs-field-label">Employer</label>
				<input type="text" name="employer" required>				
			</div>			
		</div>

		<label class="drs-field-label">Work Title (Optional)</label>
		<input type="text" name="workTitle">			

		<label class="drs-field-label">Work Phone</label>
		<input type="text" name="workPhone" required>		


		<label class="drs-field-label">Time at Job</label>
		<div class="d-flex align-items-center">
			<input style="max-width:75px" type="number" name="yearsAtJob" required>
			&nbsp;<span>Years</span>&nbsp;

			<input style="max-width:75px" type="number" name="monthsAtJob" required>
			&nbsp;<span>Months</span>
		</div>			

		<hr>
		<p class="text-left"><strong>Income: Please enter all sources of income you wish us to consider.</strong></p>

		<p class="note">** Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for replaying this obligation.</p>

		<br>
		<label class="drs-field-label">Income</label>

		<div id="pmdrs-income-inputs-list">
			
		</div>		

	</div>
</div>`,
            nextText: "Review",
            validation: () => {
                return thisFinancingForm.stepValidation(2);
            },
        });

        let refreshReview = function () {
            thisFinancingForm.refreshReview();
        };
        this.stepper.addStep({
            content: `<div class="financing-form-page4">
	<h2 class="section-title">Review</h2>

	<div class="financing-form-review">
		<table>
			<tbody id="financing-form-review-tbody">				
			</tbody>
		</table>

		<div>Terms, Conditionas and Privacy Notice</div>
		<div>
			<div class="long-text">
				The words "you", "your" and "yours" mean each person submitting this application. The words "we", "us", "our" and "ours" as used below refer to the dealer and to the Financial Institutions selected to receive your application. You authorize the dealer, as part of the credit underwriting process, to submit this application and any other application submitted in connection with the proposed transaction to the Financial Institutions disclosed to you by the dealer, for review. In addition, in accordance with the Fair Credit Reporting Act, you authorize that such Financial Institutions may submit your applications for review to other Financial Institutions that may want to purchase your contract. You agree that we and any Financial Institutions to which your application is submitted may obtain a consumer credit report periodically from one or more consumer reporting agencies (credit bureaus) in connection with the proposed transaction and any update, renewal, refinancing, modification or extension of that transaction. You agree that we may verify your employment, pay, assets and debts, and that anyone receiving a copy of this is authorized to provide us with such information. You further authorize us to gather whatever credit and employment history we consider necessary and appropriate in evaluating this application and any other applications submitted in connection with the proposed transaction. We may keep this application and any other application submitted to us, and information about you whether or not the application is approved. You certify that the information on this application and in any other application submitted to us, is true and complete. You understand that false statements may subject you to criminal penalties. FEDERAL NOTICES IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask for your name,address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents. STATE NOTICES Arizona, California, Idaho, Louisiana, Nevada, New Mexico, Texas, Washington or Wisconsin Residents: If you, the applicant, are married and live in a community property state, you may be contacted by the dealer to provide the personal credit information on your spouse in the co-applicant section. Your spouse is not required to be a co-applicant for the credit requested unless he/she wishes to be a co-applicant. California Residents: An applicant, if married, may apply for a separate account. Maine Residents: You may purchase required insurance through any insurance agent or broker and from any insurance company that is reasonably acceptable to us. You are not required to deal with any of our affiliates when choosing an agent, broker or insurer. Your choice of a particular insurance agent, broker or insurer will not affect our credit decision, so long as the insurance provides adequate coverage with an insurer who meets our reasonable requirements. Ohio Residents: Ohio laws against discrimination require that all creditors make credit equally available to all creditworthy customers and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio Civil Rights Commission administers compliance with this law. New Hampshire Residents: If you are applying for a balloon payment contract, you are entitled, it you ask, to receive a written estimate of the monthly payment amount for refinancing the balloon payment in accord with the creditor's existing refinance programs. You would be entitled to receive the estimate before you enter into a balloon payment contract. A balloon contract is an installment sale contract with a final scheduled payment that is at least twice the amount of one of the earlier scheduled equal periodic installment payments. New York Residents: In connection with your application for credit, we may request a consumer report that contains information on your credit worthiness, credit standing, personal characteristics and general reputation. If we grant you credit, we or our servicer may order additional consumer reports in connection with any update, renewal or extension of the credit. If you ask us, we will tell you whether we obtained a consumer report and if we did, we will tell you the name and address of the consumer reporting agency that gave us the report. Vermont Residents: By clicking on "Submit", you authorize us and our employees or agents to obtain and verify information about you (including one or more credit reports, information about your employment and banking and credit relationships) that we may deem necessary or appropriate in evaluating your application. If your application is approved and credit is extended, you also authorize us, and our employees and agents, to obtain additional credit reports and other information about you in connection with reviewing the account, increasing the available credit on the account (if applicable), taking collection on the account, or for any other legitimate purpose. Married Wisconsin Residents: Wisconsin law provides that no provision of any marital property agreement, or unilateral statement, or court order applied to marital property will adversely affect a creditor's interests unless, prior to the time that the credit is granted, the creditor is furnished with a copy of the agreement, statement or decree, or has actual knowledge of the adverse provision. If you are making this application individually, and not jointly with your spouse, the dealer may contact you for the full name and current address of your spouse, which must be properly disclosed. By clicking on "Submit", I acknowledge and declare that I have read and agree with the Terms of Use. I certify that I have provided complete and true information in this application.
			</div>	

			<div>
				<input class="drs-input" type="checkbox" name="termsAndConditionsCheck" required/>
				<div class="d-inline" >I have read and agree the <strong>Terms and Conditions</strong> By clicking "Submit", I authorize you to check my credit report  </div>
			</div>

			<div>
				<input class="drs-input" type="checkbox" name="privacyNoticeCheck" required/>
				<div class="d-inline">I have read and agree the terms of the <a class="pmdrs-popup-btn" href="" data-targetid="privacy_notice" data-title="Privacy Notice" id="privacy_notice_btn">Privacy Notice</a> </div>
			</div>
		</div>

		<button class="bg-black color-white" type="submit">Submit</button>
	</div>

	<div class="pmdrs-popup-content" id="privacy_notice">
		You understand and agree that you are applying for credit by providing the information to complete and submit this credit application. We may keep this application and any other application submitted to us and information about you whether or not the application is approved. You certify that the information on the application and in any other application submitted to us, is true and complete. You understand that false statements may subject you to criminal penalties.
The words “you”, “your” and “yours” mean each person submitting this application. The words “we”, “us”, “our” and “ours” as used below refer to us, the dealer, and to the financial institution(s) selected to receive your application.

You authorize us to submit this application and any other application submitted in connection with the proposed transaction to the financial institutions disclosed to you by us the dealers. This application will be reviewed by such financial institutions on behalf of themselves and us the dealer. In addition, in accordance with the Fair Credit Reporting Act, you authorize that such financial institutions may submit your applications to other financial institutions for the purpose of fulfilling your request to apply for credit. 

You agree that we may obtain a consumer credit report periodically from one or more consumer reporting agencies (credit bureaus) in connection with the proposed transaction and any update, renewal, refinancing, modification or extension of that transaction. You also agree that we or any affiliate of ours may obtain one or more consumer credit reports on you at any time whatsoever. If you ask, you will be told whether a credit report was requested, and if so, the name and address of any credit bureau from which we or our affiliate obtained your credit report.

You agree that we may verify your employment, pay, assets and debts, and that anyone receiving a copy of this is authorized to provide us with such information. You further authorize us to gather whatever credit and employment history we consider necessary and appropriate in evaluating this application and any other applications submitted in connection with the proposed transaction. You understand that we will rely on the information in this credit application in making our decision.

We may monitor and record telephone calls regarding your account for quality assurance, compliance, training, or similar purposes. By providing your cell phone number on this application, you are consenting to receive servicing and collection calls on your cell phone using an auto dialer or a prerecorded message. This consent applies to the dealer, who is the originating creditor in this transaction, as well as any assignee who may purchase your credit contract from the dealer.

FEDERAL NOTICES

IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT
If applicable to your credit transaction, to help the government fight the funding of terrorism and money laundering activities, Federal law requires financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, you will be asked for your name, address, date of birth, and other information to identify you. You may also be asked to see your driver's license or other identifying documents. 

STATE NOTICES

California Residents: An applicant, if married, may apply for a separate account.

Maine and Tennessee Residents: You must have physical damage insurance covering loss or damage to the vehicle for the term of the contract. For a lease, you must also have the liability insurance as described in the lease. You may purchase required insurance through any insurance agent or broker and from any insurance company that is reasonably acceptable to us. You are not required to deal with any of our affiliates when choosing an agent, broker or insurer. Your choice of a particular insurance agent, broker or insurer will not affect our credit decision, so long as the insurance provides adequate coverage with an insurer who meets our reasonable requirements.

New Hampshire Residents: If you are applying for a balloon payment contract, you are entitled, if you ask, to receive a written estimate of the monthly payment amount for refinancing the balloon payment in accord with the creditor’s existing refinance programs. You would be entitled to receive the estimate before you enter into a balloon payment contract. A balloon contract is an installment sales contract with a final scheduled payment that is at least twice the amount of one of the earlier scheduled equal periodic installment payments.

New York Residents: In connection with your application for credit, a consumer report may be obtained from a consumer reporting agency (credit bureau). If credit is extended, the party or parties extending credit or holding such credit may order additional consumer reports in connection with any update, renewal or extension of the credit. If you ask, you will be told whether a consumer report was requested and, if so, the name and address of any consumer reporting agency (credit bureau) from which such credit report was obtained.

Ohio Residents: Ohio laws against discrimination require that all creditors make credit equally available to all creditworthy customers and that credit reporting agencies maintain separate credit histories on each individual upon request. The Ohio Civil Rights Commission administers compliance with this law.

Rhode Island Residents: Consumer reports may be requested in connection with this application. Buyer has the right of free choice in selecting an insurer to provide insurance required in connection with this transaction subject to our reasonable approval in accordance with applicable law.

Vermont Residents: You authorize us and any financial institution with which this credit application is shared, and each of their respective employees or agents, to obtain and verify information about you (including one or more credit reports, information about your employment and banking and credit relationships) that they may deem necessary or appropriate in evaluating your credit application. If your credit application is approved and credit is granted, you also authorize the parties granting credit or holding your account, and their respective employees and agents, to obtain additional credit reports and other information about you in connection with reviewing the account, increasing the available credit on the account (if applicable), taking collection on the account, or for any other legitimate purpose.

Married Wisconsin Residents: No provision of any marital property agreement, any unilateral statement under Wis. Stat § 766.59 or any court decree under § 766.70 applied to marital property adversely affects our interest unless you furnish a copy of the agreement, statement, or court decree or we have actual knowledge of such adverse provision before credit is granted. If you are making this credit application individually and not jointly with your spouse, complete Section A about yourself and Section B about your non-applicant spouse. Your non-applicant spouse should not sign the credit application if you are applying for individual credit.

	</div>
</div>`,
            nextText: null,
            // validation: true,
            onShow: refreshReview,
        });
        this.stepper.init();

        this.incomeDynamicList = new DynamicList(
            this.app,
            "pmdrs-income-inputs-list",
            `<div class="d-flex align-items-center">
	<div>
		<select name="income[{index}]['source']">
			<option value="0">Select Income Source</option>
			<option>Salary/Wages</option>
			<option>Incentive or Bonus Income</option>
			<option>Retirement</option>
			<option>Child Support**</option>
			<option>Family or Spousal Support (Alimony)**</option>
			<option>Disability</option>
			<option>Housing Allowance</option>
			<option>Military Allowance</option>
			<option>Municipal Bond Interest</option>
			<option>Public Assistance Programs</option>
			<option>Social Security Benefits</option>
			<option>Workers' Compensation</option>
			<option>Other (taxable)</option>
			<option>Other (non-taxable)</option>

		</select>
	</div>

	&nbsp;&nbsp;
	<div>				
		<div class="d-flex align-items-center">
			<span>$</span>&nbsp;
			<input style="width: 100px" type="number" name="income[{index}][incomeInUSD]" required> &nbsp;
			<span class="white-space-nowrap">Per Year</span>
		</div>
	</div>
</div>`,
            "Add Additional Income +"
        );
        this.incomeDynamicList.init();
    }

    getSectionFields() {
        let incomeInputs = this.getIncomeInputs();

        return [
            [
                "applicationType",
                "firstName",
                "lastName",
                "phoneType",
                "email",
                "emailConfirmation",
                "salesFirstName",
                "salesLastName",
            ], //0

            [
                "ruralRoute",
                "addressStreetNumber",
                "addressStreetName",
                "addressStreetType",
                "aptNumber",
                "housingStatus",
                "yearsAtAddress",
                "monthsAtAddress",
                "rentInUSD",
                "birthday",
                "ssnItin",
            ], //1

            ["employmentStatus", "employer", "workTitle", "workPhone", "yearsAtJob", "monthsAtJob"].concat(
                incomeInputs
            ), //2
        ];
    }

    /**
     * Rules definition for validation
     * @return Object fieldName: [Array rules]
     */
    getValidationRules() {
        let incomeInputs = this.getIncomeInputs();

        let rules = {
            applicationType: [],
            firstName: [],
            lastName: [],
            email: [],
            emailConfirmation: ["confirm:email"],
            addressStreetNumber: [],
            addressStreetName: [],
            addressStreetType: ["not:0"],
            aptNumber: [],
            housingStatus: ["not:0"],
            yearsAtAddress: [],
            monthsAtAddress: [],
            rentInUSD: [],
            birthday: [],
            ssnItin: [],
            employmentStatus: ["not:0"],
            employer: [],
            workPhone: [],
            yearsAtJob: [],
            monthsAtJob: [],
        };

        incomeInputs.forEach((inputName) => {
            if (inputName.includes("source")) {
                rules[inputName] = ["not:0"];
            }
        });
        return rules;
    }

    /**
     * [stepValidation description]
     * @param  Array fieldsArray of strings with field names
     * @return boolean
     */
    stepValidation(index) {
        // if(index < 2)
        // return true;//to disable it for dev
        let fieldsArray = this.getSectionFields()[index];
        let validationRules = this.getValidationRules();
        let formData = this.getFormData();
        if (!formData.applicationType) {
            formData.applicationType = "";
        }

        let stepErrors = [];
        let isValid = true;
        for (const [key, value] of Object.entries(formData)) {
            if (fieldsArray.includes(key)) {
                let domElement = document.querySelector(this.getSelector('[name="' + key + '"]'));

                domElement.setCustomValidity(""); //set field as valid

                let fieldErrors = this.fieldValidation(key, value, validationRules[key]);
                if (fieldErrors.length > 0) {
                    domElement.setCustomValidity(fieldErrors.join(", "));
                }

                let isFieldValid = domElement.reportValidity();

                isValid = isValid && isFieldValid;
                if (!isValid) break;
            }
        }

        return isValid; //true if no errors
        return stepErrors.length == 0; //true if no errors
    }

    /**
     * [fieldValidation description]
     * @params String Key
     * @params Mixed value
     * @params Array rules for key and value, check switch for available rules
     * @return Array of errors (strings)
     */
    fieldValidation(key, value, rules) {
        rules = rules || [];
        var fieldErrors = [];
        rules.forEach((rule) => {
            var ruleArray = rule.split(":"); //split type and params

            switch (ruleArray[0]) {
                case "confirm":
                    let confirmationField = document.querySelector(this.getSelector("[name=" + ruleArray[1] + "]"));
                    if (value != confirmationField.value) {
                        fieldErrors.push("Email must be matching");
                    }
                    break;
                case "not": //eg. not:0
                    if (value == ruleArray[1]) {
                        fieldErrors.push("Please enter a different value");
                    }
                    break;
            }
        });
        return fieldErrors;
    }

    getIncomeInputs() {
        let incomeInputs = [];

        document
            .querySelectorAll(this.getSelector("#pmdrs-income-inputs-list input, #pmdrs-income-inputs-list select"))
            .forEach((input) => {
                incomeInputs.push(input.name);
            });
        return incomeInputs;
    }

    /**
     * [getReviewConfig description]
     * @return Object //eg. {sectionLabel : { fieldLabel : fieldNameInFormToGetValue}}
     */
    getReviewConfig() {
        let incomeInputs = this.getIncomeInputs();

        return {
            "Applicant Contact Info": {
                Name: ["firstName", "lastName"],
                "Primary Phone Number": ["phoneType", "phone"],
                Email: "email",
            },
            "Applicant Housing": {
                Address: ["addressStreetName", " addressStreetNumber", "addressStreetType"],
                "Housing Status": "housingStatus",
                "Time at Address": ["yearsAtAddress", "monthsAtAddress"],
                "Date of Birth": "birthday",
                "SSN / ITIN": "ssn_itin",
            },
            "Applicant Employment": {
                "Employment Status": "employmentStatus",
                Employer: "employer",
                "Work Title": "workTitle",
                "Work Phone": "workPhone",
                "Time at Job": ["yearsAtJob", "monthsAtJob"],
                Income: incomeInputs,
            },
        };
    }

    /**
     * [getFormData description]
     * @return  object formData key value of fields in form
     */
    getFormData() {
        let form = this.getFormElement();
        let data = FormatHelper.formToArray(form);
        return FormatHelper.arrayOfObjectsToKeyValue(data, "name", "value");
    }

    refreshReview() {
        let data = this.getFormData();

        let reviewConfig = this.getReviewConfig(data);

        let tbody = document.querySelector(this.getSelector("#financing-form-review-tbody"));
        var rowsHtml = "";
        var sectionCounter = -1;
        for (const [sectionName, sectionConfig] of Object.entries(reviewConfig)) {
            rowsHtml += this.getSectionRowHTML(sectionName, ++sectionCounter);

            for (const [fieldName, fieldKey] of Object.entries(sectionConfig)) {
                var valueToShow = this.getValueToShow(fieldKey, data);

                rowsHtml += this.getFieldRowHTML(fieldName, valueToShow);
            }
        }

        tbody.innerHTML = rowsHtml;
        this.stepper.registerStepBtnHandler(this.getSelector("a.review-step-btn"));
    }

    getValueToShow(fieldKeyOrArray, formData) {
        var thisFinancingForm = this;
        var valueToShowArray = [];

        var addValue = function (key) {
            let val = thisFinancingForm.formatFieldValue(key, formData[key]);
            if (val.length > 0) {
                valueToShowArray.push(val);
            }
        };

        if (!Array.isArray(fieldKeyOrArray)) {
            fieldKeyOrArray = [fieldKeyOrArray];
        }

        fieldKeyOrArray.forEach(addValue);

        return valueToShowArray.join(" ");
    }

    formatFieldValue(key, value) {
        if (!value || value.length == 0) {
            return "";
        }

        key = key.toLowerCase().includes("usd") ? "currency" : key;

        switch (key) {
            case "ssnItin":
                value = FormatHelper.ssnFormat(value);
                break;
            case "currency":
                value = FormatHelper.currencyFormat(value);
                break;
            case "phoneType":
                value = FormatHelper.ucfirst(value) + ":";
                break;
            case "monthsAtAddress":
            case "monthsAtJob":
                value = value + " months";
                break;
            case "yearsAtAddress":
            case "yearsAtJob":
                value = value + " years";
                break;
        }

        return value;
    }

    getSectionRowHTML(title, stepIndex) {
        return `<tr>
			<td class='pmdrs-bgc-1 text-left'>${title}</td>
			<td class='pmdrs-bgc-1 text-right'> 
				<a class='cursor-pointer review-step-btn' data-index_target=${stepIndex}>
					<i class='fa fa-edit'></i> Edit
				</a> 
			</td>
		</tr>`;
    }

    getFieldRowHTML(label, value) {
        return `<tr>
			<td class='text-right'>${label}</td>
			<td class='text-left'>${value}</td>
		</tr>`;
    }

    setupPopups() {
        //PRIVACY POLICY
        let privacyNoticePP = new Popup(this.app, "privacy_notice_btn");
        privacyNoticePP.init();
        this.popups.push(privacyNoticePP);

        //SSN
        let ssnPP = new Popup(this.app, "ssn_popup_btn");
        ssnPP.init();
        this.popups.push(ssnPP);

        //SSN
        let appDisclaimerPP = new Popup(this.app, "aplication_disclaimer_popup_btn");
        appDisclaimerPP.init();
        this.popups.push(appDisclaimerPP);
    }

    getHtml() {
        return `<div class="financing-form-container">

	<form  method="post"  id="pmdrs-financing-form" action="" >
		<div class="pmdrs-hidden-fields">
    <div class="hidden-group">
        <label class="finance-label" for="site_token">Site Token</label>
        <input type="text" class="pmdrs-hidden-field" name="st">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="form_title">Form Title</label>
        <input type="text" class="pmdrs-hidden-field" name="form_title" value="Get Pre-Approved">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="form_description">Form Description</label>
        <input type="text" class="pmdrs-hidden-field" name="form_description" value="Get Pre-Approved">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="provider_id">Provider Id</label>
        <input type="text" class="pmdrs-hidden-field" name="provider_id">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="form_version">Form Version</label>
        <input type="text" class="pmdrs-hidden-field" name="form_version" value="0">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="ip">IP</label>
        <input type="text" class="pmdrs-hidden-field" name="ip">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="source_url">Source Url</label>
        <input type="text" class="pmdrs-hidden-field" name="source_url"><!-- value added with javascript -->
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="source_host">Source Host</label>
        <input type="text" class="pmdrs-hidden-field" name="source_host"><!-- value added with javascript -->
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="source_path">Source Path</label>
        <input type="text" class="pmdrs-hidden-field" name="source_path"><!-- value added with javascript -->
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="source_query">Source Query</label>
        <input type="text" class="pmdrs-hidden-field" name="source_query">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="clickedatField">Clicked At Field</label>
        <input type="text" class="pmdrs-hidden-field" name="clickedatField">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="user_agent">User Agent</label>
        <input type="text" class="pmdrs-hidden-field" name="user_agent">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="sbjs_current">sbjs Current</label>
        <input type="text" class="pmdrs-hidden-field" name="sbjs_current">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="sbjs_promo">sbjs Promo</label>
        <input type="text" class="pmdrs-hidden-field" name="sbjs_promo" >
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="formTypeField">Form Type Field</label>
        <input type="text" class="pmdrs-hidden-field" name="formTypeField" value="Get Pre-Approved">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="displayTypeField">Display Type Field</label>
        <input type="text" class="pmdrs-hidden-field" name="displayTypeField" value="in-page">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="production">Production</label>
        <input type="text" class="pmdrs-hidden-field" name="production">
    </div>
    <div class="hidden-group">
        <label class="finance-label" for="refererURL">Referer URL</label>
        <input type="text" class="pmdrs-hidden-field" name="refererURL" value="">
    </div>

</div>
		<!-- action="https://secure.dev.pixelmotiondemo.com/" -->
		<div id="ff-stepper">
			
		</div>
	</form>
</div>	`;
    }

    setData(cashDown, creditRating, loanMonths, tradeInData) {
        this.cashDown = cashDown;
        this.creditRating = creditRating;
        this.loanMonths = loanMonths;
        this.tradeInData = tradeInData;
        // this.apr = this.app.aprByRatingAndMonths('finance',creditRating, loanMonths);
        // this.monthlyPayment = this.app.getFinanceMonthlyPayment(cashDown, creditRating, loanMonths);

        // this.updateUIValues();
        // RequestHelper.ajax('POST','https://httpbin.org/post',{'field1':'value1',field2:2}, (response)=> {
        // 	console.log('success in callback');
        // 	console.log(response);
        // });
    }

    updateUIValues() {
        let app = this.app;
        DOMHelper.setInnerHTML(app.getSelector(".cash-down-value"), FormatHelper.currencyFormat(this.cashDown));
        DOMHelper.setInnerHTML(
            app.getSelector(".monthly-payment-value"),
            FormatHelper.currencyFormat(this.monthlyPayment)
        );
        DOMHelper.setInnerHTML(
            app.getSelector(".base-price-value"),
            FormatHelper.currencyFormat(this.app.config.vehicle.finalPrice)
        );
        DOMHelper.setInnerHTML(
            app.getSelector(".credit-rating-value"),
            this.app.creditRatingDisplay(this.creditRating)
        );
        DOMHelper.setInnerHTML(
            app.getSelector(".loan-term-value"),
            this.app.loanTermDisplay(this.loanMonths, this.apr)
        );
        DOMHelper.setInnerHTML(app.getSelector(".loan-months-value"), this.loanMonths);
        DOMHelper.setInnerHTML(app.getSelector(".apr-value"), this.apr);
        DOMHelper.setInnerHTML(app.getSelector(".v-condition-value"), this.app.config.vehicle.condition);
        DOMHelper.setInnerHTML(app.getSelector(".v-year-value"), this.app.config.vehicle.year);
        DOMHelper.setInnerHTML(app.getSelector(".v-make-value"), this.app.config.vehicle.make);
        DOMHelper.setInnerHTML(app.getSelector(".v-model-value"), this.app.config.vehicle.model);
        DOMHelper.setInnerHTML(
            app.getSelector(".trade-in-estimated-value"),
            FormatHelper.currencyFormat(this.tradeInData.tradeInEstimate)
        );
        // DOMHelper.setInnerHTML(this.getSelector(".loan-term-value"), months);
    }

    updateVehicleImageSrc() {
        // Only overwrite when there's a real photo — an empty imgUrl would otherwise set src="",
        // which browsers resolve to the current page URL instead of a catchable image error.
        if (this.app.config.vehicle.imgUrl) {
            document.querySelector(this.app.getSelector(".vehicle-img")).src = this.app.config.vehicle.imgUrl;
        }
    }

    eventHandlers() {
        DOMHelper.addHandler(this.getSelector(".form-card-btn"), "click", (event) => {
            alert(event.target.dataset["target"]);
        });

        DOMHelper.addHandler(this.getSelector("#finance_ssn_txt"), "keyup", (event) => {
            event.target.value = FormatHelper.ssnFormat(event.target.value);
        });

        DOMHelper.addHandler(this.getSelector(".only-letters"), "keypress", (event) => {
            if (
                (event.charCode > 64 && event.charCode < 91) ||
                (event.charCode > 96 && event.charCode < 123) ||
                event.charCode == 32
            ) {
                return true;
            }
            event.preventDefault();
            // event.target.value = FormatHelper.noNumbers(event.target.value);
        });
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }
}
